import { Pipe, PipeTransform } from '@angular/core';
import { RelationshipStatus } from '../models/enum/shared/relationship-status';
import { RelationshipStatusUtils } from '../utils/relationship-status-utils';

@Pipe({
  name: 'relationshipStatusEffectiveDateLabel',
  standalone: true
})
export class RelationshipStatusEffectiveDateLabelPipe implements PipeTransform {
  transform(value?: RelationshipStatus | null): string {
    return RelationshipStatusUtils.getRelationshipStartDateLabel(value ?? null);
  }
}
